import {Food} from "./types";

const BreakfastPancakes: Food = {
    "Pancake Breakfast": {
        "Buttermilk Pancakes": "2",
        "Scrambled Eggs": "3 oz",
        "Turkey Bacon": "2 slices",
        "Sides": "Maple Syrup"
    },
    "Protein PB Pancakes": {
        "Protein PB Pancakes": "2",
        "Turkey Sausage": "1",
        "Sides": "Strawberry Jam"
    },
    "Blueberry Pancakes": {
        "Protein Blueberry Pancakes": "2",
        "Turkey Sausage": "2",
        "Sides": "Sugar-Free Syrup"
    },
    "Oreo Pancakes": {
        "Oreo Pancakes": "2",
        "Scrambled Eggs": "3oz\n(Green Scoop)",
        "Candied Bacon": "2 pcs",
        "Sides": "Sugar-Free Syrup"
    }
}

export default BreakfastPancakes